import { render } from 'react-dom'
import App from './App';

export default (domElement, configs, sellerInfo, listings, requestedListingId = null, embeddedCheckout = null, embeddedCheckoutElement = null) => {
    const renderApp = (embedError: boolean = false) => {
        render(
            <App
                configs={configs}
                sellerInfo={sellerInfo}
                listings={listings}
                requestedListingId={+requestedListingId}
                embeddedCheckout={embeddedCheckout}
                embedCaughtRenderingError={embedError}
            />,
            domElement
        )
    }
    if (embeddedCheckout && embeddedCheckoutElement) {
        embeddedCheckout.setRenderingErrorCallback(() => {
            renderApp(true);
        })
        embeddedCheckout.embed(embeddedCheckoutElement);
    }
    renderApp();
}
